module.exports = __webpack_public_path__ + "static/media/couple-using-tech.4b52e883.jpg";